import {Skeleton} from "primereact/skeleton"
import {useEffect} from "react"
import useSWR from "swr"

import {PreceptorCompletedOrientationSummary} from "../components/preceptor/PreceptorCompletedOrientationSummary"
import SubHeader from "../components/SubHeader"
import {fetcherGet, ORIENTATION_STATUS} from "../utilities/general"

const PreceptorCompletedOrientations = () => {
    useEffect(() => {
        document.title = "My Completed Orientations"
    }, [])
    const {data: orientations, isLoading} = useSWR("/preceptorships?status=Completed&status=Attritioned", fetcherGet, {
        fallbackData: [],
    })

    return (
        <>
            <SubHeader title1="" title2="My Orientees" icon="fa-user-nurse" children={null} />
            <div className="container d-flex flex-column">
                {isLoading ? (
                    <div className="card mt-4">
                        <Skeleton width="100%" height="10rem" />
                    </div>
                ) : (
                    <>
                        <div className="d-flex flex-wrap gap-4 mt-6">
                            <div className="border rounded flex-fill py-3 px-4 w-100 w-md-auto bg-white border-gray-400">
                                <div className="d-flex align-items-center">
                                    <div className="fs-2 fw-bold">{orientations.length}</div>
                                </div>
                                <div className="fw-semibold fs-6">Total Orientations</div>
                            </div>
                            <div className="border rounded flex-fill py-3 px-4 w-100 w-md-auto bg-white border-gray-400">
                                <div className="d-flex align-items-center">
                                    <div className="fs-2 fw-bold">
                                        {
                                            orientations.filter(
                                                (o) => o.orientation_status_id === ORIENTATION_STATUS.COMPLETED
                                            ).length
                                        }
                                    </div>
                                </div>
                                <div className="fw-semibold fs-6">Successful</div>
                            </div>
                            <div className="border rounded flex-fill py-3 px-4 w-100 w-md-auto bg-white border-gray-400">
                                <div className="d-flex align-items-center">
                                    <div className="fs-2 fw-bold">
                                        {orientations.filter((o) => o.orientation_status_id === ORIENTATION_STATUS.ATTRITIONED).length}
                                    </div>
                                </div>
                                <div className="fw-semibold fs-6">Attritioned</div>
                            </div>
                        </div>
                        {orientations.map((orientation) => (
                            <PreceptorCompletedOrientationSummary orientation={orientation} key={orientation.id} />
                        ))}
                    </>
                )}
            </div>
        </>
    )
}

export default PreceptorCompletedOrientations
